import React, { useState } from 'react';
import { motion } from 'framer-motion';
import OrderForm from './OrderForm';

const FinalCTASection = () => {
  const [isOrderFormOpen, setIsOrderFormOpen] = useState(false);
  const [selectedPackage, setSelectedPackage] = useState('hardcopy');

  const handleOrderClick = (packageType) => {
    setSelectedPackage(packageType);
    setIsOrderFormOpen(true);
  };

  return (
    <section className="py-20 px-4 bg-gradient-to-br from-[#333333] to-[#1a1a1a] text-white relative overflow-hidden">
      {/* Background Elements */}
      <div className="absolute inset-0 opacity-5">
        <div className="absolute top-20 left-10 w-32 h-32 border border-white rounded-full"></div>
        <div className="absolute bottom-20 right-20 w-24 h-24 border border-white rounded-full"></div>
        <div className="absolute top-1/2 left-1/4 w-16 h-16 border border-white rounded-full"></div>
      </div>

      <div className="max-w-4xl mx-auto text-center relative z-10">
        <motion.h2
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8 }}
          viewport={{ once: true }}
          className="text-4xl md:text-6xl font-bold mb-8 leading-tight"
          style={{ fontFamily: 'Kanit,sans-serif' }}
        >
          พร้อมที่จะเลิกเหนื่อย...แล้วหรือยัง?
        </motion.h2>

        <motion.p
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.2 }}
          viewport={{ once: true }}
          className="text-xl md:text-2xl mb-12 leading-relaxed text-gray-300"
          style={{ fontFamily: 'Sarabun,serif' }}
        >
          ถึงเวลาหยุดวิ่งตามโลกที่หมุนเร็วเกินไป แล้วกลับมาฟังเสียงหัวใจของตัวเอง <br />
          ค้นพบจังหวะชีวิตที่ลงตัวและมีความสุขอย่างยั่งยืน <br />
          <span className="text-[#E07A5F] font-semibold">หนังสือและคอร์สเรียนนี้คือเข็มทิศที่คุณตามหา</span>
        </motion.p>

        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.4 }}
          viewport={{ once: true }}
          className="space-y-4"
        >
          <p className="text-lg mb-8 text-[#E07A5F] font-semibold" style={{ fontFamily: 'Kanit,sans-serif' }}>
            สั่งซื้อวันนี้ เพื่อเริ่มต้นชีวิตในจังหวะใหม่ของคุณ!
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
            <motion.button
              whileHover={{ scale: 1.05, boxShadow: "0 10px 25px rgba(224,122,95,0.3)" }}
              whileTap={{ scale: 0.95 }}
              onClick={() => handleOrderClick('hardcopy')}
              className="bg-[#E07A5F] hover:bg-[#d16847] text-white font-bold py-4 px-8 rounded-full text-lg transition-all duration-300 shadow-lg"
            >
              สั่งซื้อฉบับปกแข็ง (คุ้มที่สุด)
            </motion.button>
            <motion.button
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.95 }}
              onClick={() => handleOrderClick('ebook')}
              className="bg-transparent border-2 border-[#6082B6] text-[#6082B6] hover:bg-[#6082B6] hover:text-white font-bold py-4 px-8 rounded-full text-lg transition-all duration-300"
            >
              สั่งซื้อ E-Book
            </motion.button>
          </div>
        </motion.div>

        {/* Trust Indicators */}
        <motion.div
          initial={{ opacity: 0 }}
          whileInView={{ opacity: 1 }}
          transition={{ duration: 0.8, delay: 0.6 }}
          viewport={{ once: true }}
          className="mt-16 pt-8 border-t border-gray-700"
        >
          <div className="flex flex-wrap justify-center items-center gap-8 text-sm text-gray-400">
            <div className="flex items-center space-x-2">
              <div className="w-3 h-3 bg-green-500 rounded-full"></div>
              <span>ส่งฟรีทั่วประเทศ</span>
            </div>
            <div className="flex items-center space-x-2">
              <div className="w-3 h-3 bg-green-500 rounded-full"></div>
              <span>รับประกันคุณภาพ</span>
            </div>
            <div className="flex items-center space-x-2">
              <div className="w-3 h-3 bg-green-500 rounded-full"></div>
              <span>สั่งซื้อง่าย ปลอดภัย</span>
            </div>
          </div>
        </motion.div>
      </div>

      {/* Order Form Modal */}
      <OrderForm 
        isOpen={isOrderFormOpen}
        onClose={() => setIsOrderFormOpen(false)}
        selectedPackage={selectedPackage}
      />
    </section>
  );
};

export default FinalCTASection;